import { render, staticRenderFns } from "./CultivationCardAvatar.vue?vue&type=template&id=099f1d28&scoped=true&"
import script from "./CultivationCardAvatar.vue?vue&type=script&lang=js&"
export * from "./CultivationCardAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CultivationCardAvatar.vue?vue&type=style&index=0&id=099f1d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f1d28",
  null
  
)

export default component.exports